import { Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";

function ResetWorkoutProfileDrawer({
  profileName,
  handleCloseDrawer,
  handleReset,
  workoutTypeName,
}: {
  profileName?: string;
  handleCloseDrawer: () => void;
  handleReset: () => void;
  workoutTypeName: string;
}) {
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" gap={2} px={4} pb={3} pt={4} flexDirection="column" alignItems="center">
        <Typography variant="prose-lg-medium" textAlign="center">
          <Trans>
            Reset &quot;{profileName}&quot; to {workoutTypeName.toLowerCase()}?
          </Trans>
        </Typography>
        <Typography variant="prose-base" textAlign="center">
          <Trans>
            This will remove all customization and reset the workout profile to{" "}
            {workoutTypeName.toLowerCase()} defaults.
          </Trans>
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" p={3} gap={1.5}>
        <Button
          variant="outlined"
          size="large"
          fullWidth
          onClick={() => {
            handleCloseDrawer();
          }}
        >
          <Trans>Cancel</Trans>
        </Button>
        <Button color="error" variant="outlined" size="large" fullWidth onClick={handleReset}>
          <Trans>Reset to default</Trans>
        </Button>
      </Box>
    </Box>
  );
}

export default ResetWorkoutProfileDrawer;
